import { render, staticRenderFns } from "./LessonDetails.vue?vue&type=template&id=825e685c&scoped=true"
import script from "./LessonDetails.vue?vue&type=script&lang=js"
export * from "./LessonDetails.vue?vue&type=script&lang=js"
import style0 from "./LessonDetails.vue?vue&type=style&index=0&id=825e685c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e685c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('825e685c')) {
      api.createRecord('825e685c', component.options)
    } else {
      api.reload('825e685c', component.options)
    }
    module.hot.accept("./LessonDetails.vue?vue&type=template&id=825e685c&scoped=true", function () {
      api.rerender('825e685c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/manage-lesson/LessonDetails.vue"
export default component.exports